import './cocktailseverest/style';
import FormStructure from './cocktailseverest/form_structure';

export default FormStructure;